<template>
  <div class="comparative-actions">
    <div v-if="isLoading" class="loader">
      <!-- <b-spinner
        variant="primary"
        type="grow"
        :label="`${this.$t('reports.loadingLabel')}...`"
      ></b-spinner>  -->

      <b-table striped :items="[0, 1, 2, 3]" :fields="fields">
        <template v-slot:cell(name)>
          <idx-skeleton height="15" radius="10" class="mt-2" />
        </template>
        <template v-slot:cell(totalInvites)>
          <idx-skeleton height="15" radius="10" class="mt-2" />
        </template>
        <template v-slot:cell(conversionRate)>
          <idx-skeleton height="15" radius="10" class="mt-2" />
        </template>
        <template v-slot:cell(total)>
          <idx-skeleton height="15" radius="10" class="mt-2" />
        </template>
        <template v-slot:cell(promoters)>
          <idx-skeleton height="15" radius="10" class="mt-2" />
        </template>
        <template v-slot:cell(passive)>
          <idx-skeleton height="15" radius="10" class="mt-2" />
        </template>
        <template v-slot:cell(detractors)>
          <idx-skeleton height="15" radius="10" class="mt-2" />
        </template>
        <template v-slot:cell(nps)>
          <idx-skeleton height="30" width="30" radius="100" />
        </template>
      </b-table>
    </div>
    <div v-else class="row">
      <div v-if="!isLoading" class="col-12">
        <b-table
          :id="isPanel ? 'size-panels' : ''"
          striped
          :items="items"
          :fields="fields"
          :busy="busy"
          :per-page="10"
          :current-page="currentPage"
        >
          <!--
          <template v-slot:table-busy>
            <div class="text-center my-2">
              <b-spinner
                variant="primary"
                type="grow"
                label="Loading..."
              ></b-spinner>
            </div>
          </template>
          -->
          <template v-slot:cell(action_name)="row" :style="`font-size: ${fontSize}px;`">{{
            row.item.name
          }}</template>
          <template v-slot:cell(promoters)="row"
            >{{ percentilPromoters(row.item) }}%</template
          >
          <template v-slot:cell(passive)="row"
            >{{ percentilPassive(row.item) }}%
          </template>
          <template v-slot:cell(detractors)="row"
            >{{ percentilDetractors(row.item) }}%</template
          >
          <template v-slot:cell(nps)="row">
            <radial-progress-bar
              :diameter="50"
              :stroke-width="5"
              innerStrokeColor="#f1f1f1"
              :startColor="
                npsColor(
                  myMetric === 'like-dislike'
                    ? row.item.nps * 100
                    : row.item.nps,
                )
              "
              :stopColor="
                npsColor(
                  myMetric === 'like-dislike'
                    ? row.item.nps * 100
                    : row.item.nps,
                )
              "
              :completed-steps="
                parseInt(
                  myMetric === 'like-dislike'
                    ? row.item.nps * 100
                    : row.item.nps,
                )
              "
              :total-steps="totalSteps"
            >
              <animated-number
              style="font-size: 12px;"
                :value="
                  myMetric === 'like-dislike'
                    ? row.item.nps * 100
                    : row.item.nps
                "
                :formatValue="formatToPrice"
                :duration="1000"
              />
              <b-tooltip target="number-nps" placement="bottom"></b-tooltip>
            </radial-progress-bar>
          </template>
        </b-table>
      </div>
    </div>
    <div class="row" v-if="items.length">
      <div class="col-6">
        <div class="mt-4 mb-4">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalActionList"
            :per-page="10"
            aria-controls="table-comparative-actions"
          ></b-pagination>
        </div>
      </div>
      <div class="col-6 mt-2 text-right">
        <a @click="exportToXLS" title="Exportar para XLS">
          <span class="xls">
            <i class="fas fa-file-download"></i>
          </span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import RadialProgressBar from 'vue-radial-progress';
import animatedNumber from 'animated-number-vue';
import Paginate from 'vuejs-paginate';
import XLSX from 'xlsx';
import idxSkeleton from '@/components/molecules/idx-skeleton';
import EventBus from '../../../eventBus';
import api from '../../../services/api';

export default {
  name: 'ComparativeActions',

  props: ['dataGraph'],

  components: {
    RadialProgressBar,
    animatedNumber,
    Paginate,
    idxSkeleton,
  },

  data: () => ({
    userAuth: null,
    busy: false,
    fields: [],
    items: [],
    currentPage: 1,
    totalSteps: 100,
    newItems: [],
    isPanel: false,
    isLoading: false,
  }),

  watch: {
    actionGroupData: function watchActionGroup() {
      this.getComparativeActionsData();
    },

    myMetric: function watchMyMetric() {
      this.getComparativeActionsData();
      this.changeLabel();
    },

    myIh1: function watchMyIh1() {
      this.getComparativeActionsData();
    },

    myHierarchies1: function watchMyHierarchies1() {
      this.getComparativeActionsData();
    },

    myHierarchies2: function watchMyHierarchies2() {
      this.getComparativeActionsData();
    },

    myIh2: function watchMyIh2() {
      this.getComparativeActionsData();
    },

    myActionId: function watchMyActionId() {
      this.getComparativeActionsData();
    },

    myActionsIds: function watchMyActionsIds() {
      this.getComparativeActionsData();
    },

    calendarDates: async function watchDates() {
      this.getComparativeActionsData();
    },

    'indicatorData.value': function watchIndicatorData() {
      this.getComparativeActionsData();
    },
    'indicatorData.period': async function watchIndicatorPeriod() {
      await this.getComparativeActionsData();
    },
  },

  computed: {
    ...mapState('charts', ['ItemsComparativeActions', 'totalActionList']),
    ...mapState('branches', ['myIh1', 'myIh2', 'myHierarchies1', 'myHierarchies2']),
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('companies', ['myMetric']),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('indicators', ['indicatorName', 'indicatorData']),
  },

  methods: {
    ...mapActions('charts', ['comparativeActions']),
    getComparativeActionsData() {
      this.items = [];
      this.isLoading = true;
      this.comparativeActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        page: this.page,
        limit: 10,
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.isLoading = false;
        this.items = this.ItemsComparativeActions;
      });
    },
    percentilDetractors({ promoters, passive, detractors }) {
      const total = promoters + passive + detractors;
      let result;
      if (total > 0) {
        result = parseFloat(((detractors / total) * 100).toFixed(1));
      } else {
        return 0;
      }
      return result;
    },

    percentilPassive({ promoters, passive, detractors }) {
      const total = promoters + passive + detractors;
      let result;
      if (total > 0) {
        result = parseFloat(((passive / total) * 100).toFixed(1));
      } else {
        return 0;
      }
      return result;
    },

    percentilPromoters({ promoters, passive, detractors }) {
      const total = promoters + passive + detractors;
      let result;
      if (total > 0) {
        result = parseFloat(((promoters / total) * 100).toFixed(1));
      } else {
        return 0;
      }
      return result;
    },

    npsColor(number) {
      let color;
      if (
        this.myMetric.indexOf('nps') !== -1
      ) {
        if (number === 0) color = '#d62027';
        if (number < 10) color = '#ff0000';
        if (number >= 10 && number < 20) color = '#f05223';
        if (number >= 20 && number < 30) color = '#f36f21';
        if (number >= 30 && number < 40) color = '#faa823';
        if (number >= 40 && number < 50) color = '#ffca27';
        if (number >= 50 && number < 60) color = '#ecdb12';
        if (number >= 60 && number < 70) color = '#e8e73d';
        if (number >= 70 && number < 80) color = '#c5d92d';
        if (number >= 80 && number < 90) color = '#afd136';
        if (number >= 90 && number <= 100) color = '#4ce595';
      } else if (this.myMetric.indexOf('ces') !== -1 ||
         this.myMetric.indexOf('csat-1-5(media)') !== -1) {
        if (number <= 1) color = '#ff0000';
        if (number >= 1 && number < 2) color = '#f05223';
        if (number >= 2 && number < 3) color = '#faa823';
        if (number >= 3 && number < 4) color = '#e8e73d';
        if (number >= 4 && number < 5) color = '#afd136';
        if (number >= 5) color = '#4ce595';
      } else if (
        this.myMetric === 'csat-0-10(media)'
      ) {
        if (number === 0) color = '#d62027';
        if (number < 1) color = '#ff0000';
        if (number >= 1 && number < 2) color = '#f05223';
        if (number >= 2 && number < 3) color = '#f36f21';
        if (number >= 3 && number < 4) color = '#faa823';
        if (number >= 4 && number < 5) color = '#ffca27';
        if (number >= 5 && number < 6) color = '#ecdb12';
        if (number >= 6 && number < 7) color = '#e8e73d';
        if (number >= 7 && number < 8) color = '#c5d92d';
        if (number >= 8 && number < 9) color = '#afd136';
        if (number >= 9 && number <= 10) color = '#4ce595';
      } else if (this.myMetric.indexOf('like-dislike') !== -1) {
        if (number <= 50) color = '#ff0000';
        if (number >= 60) color = '#4ce595';
      }

      return color;
    },

    formatToPrice(value) {
      if (this.myMetric.indexOf('nps') !== -1) {
        return value.toFixed(1);
      }
      return value.toFixed(1);
    },

    s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      // eslint-disable-next-line
      for (let i = 0; i < s.length; i += 1) view[i] = s.charCodeAt(i) & 0xff;
      return buf;
    },

    returnLabel(metric){
      if(metric.indexOf('nps') !== -1){
        return 'nps'
      }else if(metric.indexOf('csat') !== -1){
        return 'csat'
      }else if(metric.indexOf('ces') !== -1){
        return 'ces'
      }else if(metric.indexOf('stars') !== -1){
        return '5-stars'
      }else if(metric.indexOf('like') !== -1){
        return 'Like/Dislike'
      }
      return '-';
    },

    exportToXLS() {
      const labelMetric = this.returnLabel(this.myMetric);

      const header = [
        'nome',
        'respostas',
        '%promotores',
        '%neutros',
        '%detratores',
        `${labelMetric}`,
      ];

      const arr = [];

      this.items.forEach((el) => {
        arr.push({
          nome: el.name,
          respostas: el.total,
          '%promotores': `${el.promoters.toFixed(2)}%`,
          '%neutros': `${el.passive.toFixed(2)}%`,
          '%detratores': `${el.detractors.toFixed(2)}%`,
          [labelMetric]: el.nps.toFixed(1),
        });
      });

      const wb = XLSX.utils.book_new();

      wb.SheetNames.push('comparativo');

      const ws = XLSX.utils.json_to_sheet(arr, { header });

      // eslint-disable-next-line
      wb.Sheets['comparativo'] = ws;

      const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

      const uri = window.URL.createObjectURL(
        new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }),
      );

      const link = document.createElement('a');
      link.href = uri;
      link.setAttribute('download', 'comparativo-ações.xlsx');
      document.body.appendChild(link);
      link.click();
    },

    changeLabel() {
      if (
        this.myMetric === 'nps-0-10' && !this.isPanel
      ) {
        this.totalSteps = 100;
        this.fields = [
          {
            key: 'name',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.actionName')
              : 'Ação',
          },
          {
            key: 'totalInvites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.promoters')
              : '10-9',
          },
          {
            key: 'passive',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.neutral')
              : '8-6',
          },
          {
            key: 'detractors',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.detractors')
              : '5-0',
          },
          { key: 'nps', label: this.$t('dashboard.labelsStockComparison.nps') },
        ];
      } else if (
        this.myMetric === 'nps-1-5' && !this.isPanel
      ) {
        this.totalSteps = 5;
        this.fields = [
          {
            key: 'name',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.actionName')
              : 'Ação',
          },
          {
            key: 'invites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.promoters')
              : '10-9',
          },
          {
            key: 'passive',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.neutral')
              : '8-6',
          },
          {
            key: 'detractors',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.detractors')
              : '5-0',
          },
          { key: 'nps', label: this.$t('dashboard.labelsStockComparison.nps') },
        ];
      } else if (
        this.myMetric.indexOf('ces') !== -1
      ) {
        this.totalSteps = 5;
        this.fields = [
          {
            key: 'name',
            label: this.$t('dashboard.labelsStockComparison.actionName'),
          },
          {
            key: 'invites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label: '4-5',
          },
          {
            key: 'passive',
            label: '3',
          },
          {
            key: 'detractors',
            label: '1-2',
          },
          { key: 'nps', label: this.$t('dashboard.labelsStockComparison.ces') },
        ];
      } else if (
        this.myMetric === 'csat-1-5'
      ) {
        this.totalSteps = 100;
        this.fields = [
          {
            key: 'name',
            label: this.$t('dashboard.labelsStockComparison.actionName'),
          },
          {
            key: 'invites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label: '4-5',
          },
          {
            key: 'passive',
            label: '3',
          },
          {
            key: 'detractors',
            label: '1-2',
          },
          { key: 'nps', label: 'CSAT' },
        ];
      } else if (
        this.myMetric === 'csat-1-5(media)'
      ) {
        this.totalSteps = 5;
        this.fields = [
          {
            key: 'name',
            label: this.$t('dashboard.labelsStockComparison.actionName'),
          },
          {
            key: 'invites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label: '4-5',
          },
          {
            key: 'passive',
            label: '3',
          },
          {
            key: 'detractors',
            label: '1-2',
          },
          { key: 'nps', label: 'CSAT (Média)' },
        ];
      } if (
        this.myMetric === 'csat-0-10(media)' && !this.isPanel
      ) {
        this.totalSteps = 10;
        this.fields = [
          {
            key: 'name',
            label: !this.isPanel
              ? this.$t('dashboard.labelsStockComparison.actionName')
              : 'Ação',
          },
          {
            key: 'invites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label:  '9 e 10',
          },
          {
            key: 'passive',
            label: '7 e 8',
          },
          {
            key: 'detractors',
            label: '0-6',
          },
          { key: 'nps', label: 'CSAT 0-10(Média)' },
        ];
      } else if (
        (this.myMetric.indexOf('stars') !== -1 && !this.isPanel)
      ) {
        this.totalSteps = 5;
        this.fields = [
          {
            key: 'name',
            label: this.$t('dashboard.labelsStockComparison.actionName'),
          },
          {
            key: 'invites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label: '4-5',
          },
          {
            key: 'passive',
            label: '3',
          },
          {
            key: 'detractors',
            label: '1-2',
          },
          { key: 'nps', label: '5-Stars' },
        ];
      } else if (
        (this.myMetric === 'like-dislike' && !this.isPanel)
      ) {
        this.totalSteps = 100;
        this.fields = [
          {
            key: 'name',
            label: this.$t('dashboard.labelsStockComparison.actionName'),
          },
          {
            key: 'invites',
            label: this.$t('dashboard.labelsStockComparison.invites'),
          },
          {
            key: 'conversionRate',
            label: this.$t('dashboard.labelsStockComparison.conversionRate'),
          },
          {
            key: 'total',
            label: this.$t('dashboard.labelsStockComparison.answers'),
          },
          {
            key: 'promoters',
            label: '1',
          },
          {
            key: 'detractors',
            label: '0',
          },
          { key: 'nps', label: 'Like/Dislike' },
        ];
      }
    },

    async getDataCardPanel(dataGraph) {
      let response = null;
      response = await api.get(`/metrics/actions/${this.userAuth.companyId}`, {
        headers: { 'x-access-token': this.userAuth.token },
        params: {
          companyId: this.userAuth.companyId,
          actionId: dataGraph.actionId ? dataGraph.actionId._id : null,
          page: this.page,
          limit: 10,
          period: dataGraph.period,
          ih1: dataGraph.ih1 ? dataGraph.ih1._id : null,
          metric: dataGraph.metric,
          groupId: dataGraph.actionGroupId ? dataGraph.actionGroupId._id : null,
          indicator: dataGraph.indicator ? dataGraph.indicator : null,
          indicatorValue: dataGraph.valueIndicator
            ? dataGraph.valueIndicator
            : null,
        },
      });

      this.items = response.data.data;
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabel();
  },

  async mounted() {
    if (this.$route.fullPath.indexOf('panels') !== -1) {
      this.isPanel = true;

      this.getDataCardPanel(this.dataGraph);

      EventBus.$on('update-comparative-action', (items) => {
        this.getDataCardPanel(items);
      });

      this.changeLabel();
    } else {
      this.isPanel = false;
      this.isLoading = true;
      this.comparativeActions({
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        actionId: this.myActionsIds.length === 0 ? null : this.myActionsIds.join(','),
        page: this.page,
        limit: 10,
        startDate: this.calendarDates.start ? this.calendarDates.start : null,
        endDate: this.calendarDates.end ? this.calendarDates.end : null,
        ih1: this.myHierarchies1.length === 0 ? null : this.myHierarchies1.join(','),
        ih2: this.myHierarchies2.length === 0 ? null : this.myHierarchies2.join(','),
        metric: this.myMetric,
        groupId: this.actionGroupData._id,
        indicator: this.indicatorName,
        indicatorValue: this.indicatorData.value,
        indicatorRange: this.indicatorData.range,
      }).then(() => {
        this.isLoading = false;
        this.items = this.ItemsComparativeActions;
      });
      this.changeLabel();
    }
  },
};
</script>
<style lang="scss" scoped>
@import '@/themes/default/variables.scss';

.comparative-actions {
  .table th {
    border-top: none;
  }
}

.comparative-actions .pagination-area-config-users .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.comparative-actions .pagination-area-config-users a {
  outline: none;
}

.radial-progress-inner {
  span {
    font-size: 16px;
  }
}

.xls {
  font-size: 35px;
  color: $primary;
  cursor: pointer;
}

.xls:hover {
  color: #1dc86e;
}
</style>

<style lang="scss" scoped>
.pagination-area-config-users >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/comparative-actions/index.vue